import type { Atom } from '@exodus/atoms';
import type { Definition } from '@exodus/dependency-types';
import type { Logger } from '@exodus/logger';

import type { Assets, EnabledAssets } from '@/types';

type Dependencies = {
  logger: Logger;
  assetsAtom: Atom<{ value: Assets }>;
  enabledAssets: EnabledAssets;
};

const createTestnets = ({
  logger,
  assetsAtom,
  enabledAssets,
}: Dependencies) => {
  const getAssets = async () => {
    const { value: assets } = await assetsAtom.get();

    return Object.values(assets).filter(
      (asset) => asset.baseAsset.api?.features?.isTestnet,
    );
  };

  const disableAssets = async () => {
    const testnetAssets = await getAssets();
    const assets = testnetAssets.map((asset) => asset.name);
    await enabledAssets.disable(assets);
    logger.log('disabled testnets ', assets);
  };

  return {
    getAssets,
    disableAssets,
  };
};

export type Testnets = ReturnType<typeof createTestnets>;

const testnetsDefinition = {
  id: 'testnets',
  type: 'module',
  factory: createTestnets,
  dependencies: ['logger', 'assetsAtom', 'enabledAssets'],
} as const satisfies Definition;

export default testnetsDefinition;
